export const HITLAB_RADIO_ROUTE = '/hitlab/radio';

export const RADIO_QUEUE_KINDS = Object.freeze({
  TRACK: 'track',
  BUMPER: 'bumper',
  AUDIO_AD: 'audio_ad',
  CLICKABLE_MEDIA: 'clickable_media',
});

// Product owner confirms these V1 seed tracks and bumpers have permission for
// JG Universe / Joe Galaxy Radio Rotation streaming and display. Only include
// tracks and bumpers with explicit permission for JG Universe / Joe Galaxy Radio
// Rotation streaming and display. Tracks intended for future JGK tip/support
// must also have artist permission for JGK proceeds to be credited to artist
// wallet under existing platform fee/cashout terms. Do not include covers,
// uncleared samples, unclear beat rights, unresolved producer/feature
// permissions, or unresolved third-party sound effects.
export const RADIO_ROTATION_QUEUE = [
  {
    id: 'uneekint-dance-all-night',
    kind: RADIO_QUEUE_KINDS.TRACK,
    artistName: 'Uneekint',
    songTitle: 'Dance All Night',
    audioUrl:
      'https://res.cloudinary.com/joegalaxy/video/upload/v1786235516/1A._Uneekint_-_Dance_ALL_Night_bm4ptp.mp3',
    coverArtUrl:
      'https://res.cloudinary.com/joegalaxy/image/upload/v1786235855/sddefault_xepr3p.jpg',
    artistInstagramUrl: '',
    artistProfileUrl: '',
    rightsStatus: 'rights_clean',
    rotationStatus: 'active',
    isJoeGalaxyTrack: false,
    isInvitedArtistTrack: true,
  },
  {
    id: 'bumper-joe-galaxy-dj-drop',
    kind: RADIO_QUEUE_KINDS.BUMPER,
    title: 'Joe Galaxy DJ Drop',
    label: 'Joe Galaxy Drop',
    audioUrl:
      'https://res.cloudinary.com/joegalaxy/video/upload/v1786237385/1._1_XtraDrop-042817-JoeGalaxy_kwjitc.mp3',
    rightsStatus: 'rights_clean',
    rotationStatus: 'active',
  },
  {
    id: 'joe-galaxy-grindin-by-myself',
    kind: RADIO_QUEUE_KINDS.TRACK,
    artistName: 'Joe Galaxy',
    songTitle: 'Grindin By Myself',
    audioUrl:
      'https://res.cloudinary.com/joegalaxy/video/upload/v1782691946/12._JOE_GALAXY_-_Grindin_By_Myself_-_MASTERED_DK_320Kbps_pg1vur.mp3',
    coverArtUrl:
      'https://res.cloudinary.com/joegalaxy/image/upload/v1786236234/885d0595-c426-459c-9fcc-3169d1c5c5d4.png',
    artistInstagramUrl: 'https://www.instagram.com/thejoegalaxy',
    artistProfileUrl: '',
    rightsStatus: 'rights_clean',
    rotationStatus: 'active',
    isJoeGalaxyTrack: true,
    isInvitedArtistTrack: false,
  },
  {
    id: 'bumper-race-car',
    kind: RADIO_QUEUE_KINDS.BUMPER,
    title: 'Station Bumper',
    label: 'Race Car Sweep',
    audioUrl:
      'https://res.cloudinary.com/joegalaxy/video/upload/v1786236885/1B._Race_Car_Passing_Sound_Effect_HQ_1_copy_uab2jx.mp3',
    rightsStatus: 'rights_clean',
    rotationStatus: 'active',
  },
  {
    id: 'kebell-suso-1-man-soldier',
    kind: RADIO_QUEUE_KINDS.TRACK,
    artistName: 'Kebell Suso',
    songTitle: '1 Man Soldier',
    audioUrl:
      'https://res.cloudinary.com/joegalaxy/video/upload/v1786236678/KEBELL_1_MAN_SOLDIER_arn4ua.mp3',
    coverArtUrl:
      'https://res.cloudinary.com/joegalaxy/image/upload/v1786236575/90f63e9b-f679-4718-af37-bf888c15a73a.png',
    artistInstagramUrl: '',
    artistProfileUrl: '',
    rightsStatus: 'rights_clean',
    rotationStatus: 'active',
    isJoeGalaxyTrack: false,
    isInvitedArtistTrack: true,
  },
  {
    id: 'bumper-funkmaster-flex-bomb',
    kind: RADIO_QUEUE_KINDS.BUMPER,
    title: 'Station Bumper',
    label: 'Bomb Drop',
    audioUrl:
      'https://res.cloudinary.com/joegalaxy/video/upload/v1786236844/1._1B._Funkmaster_Flex_Bomb_sound_effect_1_copy_d3w1xe.mp3',
    rightsStatus: 'rights_clean',
    rotationStatus: 'active',
  },
  {
    id: 'joe-galaxy-im-so-drunk',
    kind: RADIO_QUEUE_KINDS.TRACK,
    artistName: 'Joe Galaxy',
    songTitle: "I'm So Drunk",
    audioUrl:
      'https://res.cloudinary.com/joegalaxy/video/upload/v1786237029/5._JOE_GALAXY_-_I_m_So_Drunk_Main_MASTERED_DK_320Kbps_isnddw.mp3',
    coverArtUrl:
      'https://res.cloudinary.com/joegalaxy/image/upload/v1786237130/f34d63f1-546e-42ad-bcb4-2b9af27a8107.png',
    artistInstagramUrl: 'https://www.instagram.com/thejoegalaxy',
    artistProfileUrl: '',
    rightsStatus: 'rights_clean',
    rotationStatus: 'active',
    isJoeGalaxyTrack: true,
    isInvitedArtistTrack: false,
  },
  {
    id: 'bumper-20th-century',
    kind: RADIO_QUEUE_KINDS.BUMPER,
    title: 'Station Bumper',
    label: 'Classic Radio Sweep',
    audioUrl:
      'https://res.cloudinary.com/joegalaxy/video/upload/v1786237328/1._20th_-_Century_tqxn7g.mp3',
    rightsStatus: 'rights_clean',
    rotationStatus: 'active',
  },
];

const V1_RENDERABLE_KINDS = new Set([
  RADIO_QUEUE_KINDS.TRACK,
  RADIO_QUEUE_KINDS.BUMPER,
]);

const isActiveRenderableItem = (item) =>
  item &&
  V1_RENDERABLE_KINDS.has(item.kind) &&
  item.rotationStatus === 'active' &&
  item.rightsStatus === 'rights_clean' &&
  Boolean(item.audioUrl) &&
  (item.kind !== RADIO_QUEUE_KINDS.TRACK || Boolean(item.coverArtUrl));

export const getActiveRadioQueue = (queue = RADIO_ROTATION_QUEUE) =>
  (Array.isArray(queue) ? queue : []).filter(isActiveRenderableItem);

export const getActiveRadioTracks = (queue = RADIO_ROTATION_QUEUE) =>
  getActiveRadioQueue(queue).filter(
    (item) => item.kind === RADIO_QUEUE_KINDS.TRACK,
  );
